export default function reportTypesDirective() {
  return {
    template: require('./report-types.html'),
    controller: 'SRReportTypesController',
    controllerAs: 'srReportTypesVM',
    bindToController: true,
    replace: true,
    scope: {
      customerId: '@',
      reportTypes: '=',
    },
  };
}
